export interface IBaseParams{
  enabled?: boolean;
  forceFallback?: boolean;
}


export enum MESSAGE_DISPLAY_MODE {
  TOASTER = 0,
  ANIMATION = 1
}

export enum MESSAGE_ANIMATION_TYPE {
  BURNOUT = 4
}

export enum PLATFORM_MESSAGE_TYPE {
  OMG = 1,
  TOASTER = 2,
  KICK = 3,
  INIT_GEO = 9,
  UPDATE_RESTRICTION_V2 = 10,
  BET_REJECTED = 12,
  PROMOTION_DISPLAY_IN_CLIENT = 13,
  TIME_BASE_PROMOTION_ELIGIBILITY_CHECK = 14,
  FREE_TO_PLAY_ELIGIBILITY_CHECK = 15,
  INTRUSIVE_MESSAGE = 16, // for example, UKGC initial warning message or BIG WIN message
  GAMBLING_SESSION_ACTION = 17,
}

export interface IntrusiveMessageData {
  MessageID: string | number;
  Title: string;
  Text: string;
  LangIso3: string;
  ButtonText: string;
  CorrelationID: string;
}

export interface IMessageData {
  PlatformMessagesType: PLATFORM_MESSAGE_TYPE;
  TroubleshooterRetry?: boolean;
  TroubleshooterMessages?: any[];
  ReasonID?: number;
}

export interface IOMGReceivedData extends IMessageData {
  DisplayInGame: 0 | 1;
  MessageData: string;
  MessageDataJson: string; //apparently this contains an array of toaster messages
  OmgType: number;
}

export interface IKickData extends IMessageData {
  KickReasonId: number;
  KickType: number;
  LimitExpirationDate?: TimeSpanFromFirebase;
  CorrelationID?: string;
  CorrelationId?: string; //Because of temporary misalignment between verticals regarding name of this param
}

export interface TimeSpanFromFirebase {
  seconds: number;
  nanoseconds: number;
}

export interface IInitGeoData extends IMessageData {
  Cid: number;
  GameCategory: number;
  GeoComplyLicense: string;
  GeoComplyWebLicense: string;
  IsPeriodicFlow: boolean;
  LocationTransactionId: string;
  Mobile: string;
  Platform: number;
  PlayerSessionId: number;
  insertData: {
    nanoseconds: number;
    seconds: number;
  };
}

export interface IRestrictionEntitiesValuesData {
  ExpirationDate: string;
  ReasonId: number;
  Value: string;
}

export interface IRestrictionEntitiesData {
  EntityId: number;
  Values: IRestrictionEntitiesValuesData[];
}

export interface IRestrictionByActionData {
  ActionId: number;
  Entities: IRestrictionEntitiesData[]
}


export interface IRestrictionData extends IMessageData {
  Cid: number;
  ReasonID: number;
  RestrictionsByAction: IRestrictionByActionData[]
}

export interface IExpirationDate {
  nanoseconds: number;
  seconds: number;
}

export interface ISubscriptionParams {
  eventName: string;
  successCallback: any;
  params?: Record<string, string>;
}

export interface IMessagesParams extends IBaseParams {
  Kick: IBaseParams;
  OMG: IOMGParams;
  Restrictions: IBaseParams;
  BetRejected: IBaseParams;
  Toasters: IToastersParams;
}

export interface IOMGParams extends IBaseParams {
  OMGVersion: string;
}

export interface IToastersParams extends IBaseParams {
  toasterVersion: string;
}

export const MESSAGES_FEATURES_DEFAULTS: IMessagesParams = {
  OMG: {
    OMGVersion: '4',
    enabled: false
  },
  Toasters: {
    toasterVersion: '1',
    enabled: false
  },
  Kick: {
    enabled: false
  },
  Restrictions: {
    enabled: false
  },
  BetRejected: {
    enabled: false
  },
  enabled: false
}

export interface IWheelOfFortuneData extends IMessageData {
  Cid: number;
  IndicationInClientPromotionsIds: number[];
  IsPromotionDisplayedInClient: boolean;
}

